export default __webpack_public_path__ + "./image/0f9c3c785175a62252abba1fb0e72dde.png";